window.$ = window.jQuery;

class Search {
  constructor() {
    Object.assign(this, {
      globalTagEl: $(".global-tag"),
      tags: [],
      page: Array.from(document.querySelectorAll(".ajax-search")).reduce(
        (acc, curr) => {
          acc[curr.id] = 1;
          return acc;
        },
        {}
      ),
    });

    this.events();
  }

  events() {
    this.globalTagEl.on("click", this.handleTagsClick.bind(this));

    $(document).on("click", ".page-numbers", this.handlePageClick.bind(this));
  }

  handleTagsClick(e) {
    const target = e.target;
    const slug = target.dataset.slug;

    if (!target.classList.contains("global-tag__item")) return;

    // Remove tag and remove active class
    if (this.tags.includes(slug)) {
      this.tags.splice(this.tags.indexOf(slug), 1);
      target.classList.remove("global-tag__item--active");
    } else {
      this.tags.push(slug);
      target.classList.add("global-tag__item--active");
    }

    this.filter();
  }

  async handlePageClick(e) {
    e.preventDefault();

    if (e.currentTarget.classList.contains("current")) return;

    const selectedPage = e.currentTarget.href.match(/\/page\/(\d+)\//)[1];

    const target = e.currentTarget.closest(".ajax-search");
    const postType = target.id;

    this.page[postType] = selectedPage;

    const response = await fetch(this.buildPath(this.page[postType]));
    const html = await response.text();

    const postTypeHtml = $(html).find(`#${postType}`);

    $(`#${postType}`).replaceWith(postTypeHtml);
  }

  buildPath(page = 1) {
    let url = window.location.origin + window.location.search;

    if (this.tags.length > 0) {
      url += "&tags=" + this.tags.join(",");
    }

    url += `&paged=${page}`;

    return url;
  }

  // On filter reset all the post type page
  async filter() {
    for (let key in this.page) {
      this.page[key] = 1;
    }
    const response = await fetch(this.buildPath());
    const html = await response.text();

    const postTypes = $(html).find(".ajax-search");

    postTypes.each((_, post) => {
      if ($(post).data("count") > 0) {
        $(`#${post.id}`).replaceWith(post);
      } else {
        $(`#${post.id}`).addClass("hidden");
      }
    });
  }
}

new Search();
